// Where a booth's "View Employer" button goes: the booth's custom View Employer link
// when an admin set one, else the booth's employer page.

// A full web address (https://…) or a page on this site (/…). Anything else, such as
// "javascript:" or "www.example.com", is not a usable link.
const ABSOLUTE_URL = /^https?:\/\/[^\s]+$/i;
const SITE_PATH = /^\/(?!\/)[^\s]*$/;

export const isValidCustomLink = (link) => {
  const value = (link || '').trim();
  return ABSOLUTE_URL.test(value) || SITE_PATH.test(value);
};

export const isExternalLink = (href) => ABSOLUTE_URL.test(href || '');

export const employerPagePath = (eventSlug, boothId) =>
  `/booth-queue/${encodeURIComponent(eventSlug)}/${encodeURIComponent(boothId)}`;

export const getViewEmployerHref = (booth, eventSlug) => {
  const customLink = (booth?.viewEmployerButtonLink || '').trim();
  if (isValidCustomLink(customLink)) return customLink;
  return employerPagePath(eventSlug, booth?._id || booth?.id);
};

// For buttons: React Router's navigate() only handles pages on this site.
export const goToHref = (navigate, href) => {
  if (isExternalLink(href)) {
    window.location.assign(href);
  } else {
    navigate(href);
  }
};
